"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationService = void 0;
var Utility_1 = require("./Utility");
var Registry_1 = require("./Registry");
var TenantRegistry_1 = require("./TenantRegistry");
var Types_1 = require("./Types");
var PlatformConfigurationService_1 = require("./PlatformConfigurationService");
var UrlAdapter_1 = require("./UrlAdapter");
var ConfigurationService = /** @class */ (function () {
    function ConfigurationService(options) {
        this.busConfiguration = {};
        this.defaultLocale = 'en';
        this.defaultEnvironment = 'staging';
        this.defaultPlatform = 'seven';
        this.options = (0, Utility_1.defaultTo)(options, {});
        this.setBusListener();
    }
    ConfigurationService.prototype.getHttpAdaptersConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var httpAdapterConfig, product, urlAdapter, urlConfiguration, httpAdaptersMap_1, httpAdapterPromises, httpAdapterConfigs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ((0, Utility_1.isNil)(this.options.productName)) {
                            throw new Error(Types_1.ConfigurationErrors.MissingProductNameError);
                        }
                        httpAdapterConfig = {};
                        product = Registry_1.registry.getProduct(this.options.productName);
                        if ((0, Utility_1.isNil)(product)) {
                            throw new Error(Types_1.ConfigurationErrors.MissingProductError);
                        }
                        urlAdapter = new UrlAdapter_1.UrlAdapter();
                        urlConfiguration = urlAdapter.getConfiguration(this.options);
                        if (!product.httpAdapters) return [3 /*break*/, 2];
                        httpAdaptersMap_1 = Registry_1.registry.httpAdapters;
                        httpAdapterPromises = product.httpAdapters.map(function (httpAdapterOptions) {
                            var httpAdapter = new httpAdaptersMap_1[httpAdapterOptions.name]({
                                environment: _this.options.environment,
                                platformName: _this.options.platformName,
                                platformDataCenter: _this.options.platformDataCenter,
                                productId: _this.options.productId,
                                productUuid: _this.options.productUuid,
                                tenantId: _this.options.tenantId,
                                productName: _this.options.productName,
                                locale: _this.options.locale,
                                applicationName: _this.options.applicationName,
                                translationDomains: _this.options.translationDomains,
                                translationsFromFrasier: _this.options.translationsFromFrasier,
                                platformConfig: _this.options.platformConfig,
                                ui: urlConfiguration.ui,
                                channel: _this.options.channel,
                                keepStaticConfigStructure: _this.options.keepStaticConfigStructure,
                                deployment: _this.options.deployment
                            });
                            return httpAdapter.getConfiguration();
                        });
                        return [4 /*yield*/, Promise.all(httpAdapterPromises)];
                    case 1:
                        httpAdapterConfigs = _a.sent();
                        Utility_1.merge.apply(void 0, __spreadArray([httpAdapterConfig], httpAdapterConfigs, false));
                        _a.label = 2;
                    case 2: return [2 /*return*/, httpAdapterConfig];
                }
            });
        });
    };
    ConfigurationService.prototype.getPlatformAdaptersConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var platformConfigurationService, platformConfiguration;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        platformConfigurationService = new PlatformConfigurationService_1.PlatformConfigurationService();
                        return [4 /*yield*/, platformConfigurationService.getConfiguration(this.options)];
                    case 1:
                        platformConfiguration = _a.sent();
                        return [2 /*return*/, platformConfiguration];
                }
            });
        });
    };
    ConfigurationService.prototype.getConfiguration = function () {
        return __awaiter(this, void 0, void 0, function () {
            var checkTime, checkIntervalTime, checkIntervalTimeout, platformConfiguration, requiredPaths, defaultMessageProtocol, callbackOptions, httpAdaptersConfiguration, tenantConfiguration, product, configuration;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        checkTime = 0;
                        checkIntervalTime = 10;
                        checkIntervalTimeout = (0, Utility_1.defaultTo)(this.options.checkIntervalTimeout, 5000);
                        return [4 /*yield*/, this.getPlatformAdaptersConfiguration()];
                    case 1:
                        platformConfiguration = _a.sent();
                        requiredPaths = this.options.requiredPaths;
                        defaultMessageProtocol = Registry_1.registry.messageProtocols.postMessage.name;
                        this.options.productName = (0, Utility_1.defaultTo)(this.options.productName, platformConfiguration.productName);
                        this.options.productId = (0, Utility_1.defaultTo)(this.options.productId, platformConfiguration.productId);
                        this.options.productUuid = (0, Utility_1.defaultTo)(this.options.productUuid, platformConfiguration.productUuid);
                        this.options.tenantId = (0, Utility_1.defaultTo)(this.options.tenantId, platformConfiguration.tenantId);
                        this.options.environment = (0, Utility_1.defaultToAny)(this.options.environment, platformConfiguration.environment, this.defaultEnvironment);
                        this.options.platformName = (0, Utility_1.defaultToAny)(this.options.platformName, platformConfiguration.platformName, this.defaultPlatform);
                        this.options.platformDataCenter = (0, Utility_1.defaultToAny)(this.options.platformDataCenter, platformConfiguration.platformDataCenter);
                        this.options.locale = (0, Utility_1.defaultToAny)(this.options.locale, platformConfiguration.locale, this.defaultLocale);
                        this.options.applicationName = (0, Utility_1.defaultToAny)(this.options.applicationName, platformConfiguration.applicationName);
                        this.options.messageProtocol = (0, Utility_1.defaultToAny)(this.options.messageProtocol, platformConfiguration.messageProtocol, defaultMessageProtocol);
                        this.options.channelId = (0, Utility_1.defaultToAny)(this.options.channelId, platformConfiguration.channelId);
                        this.options.betshopId = (0, Utility_1.defaultToAny)(this.options.betshopId, platformConfiguration.betshopId);
                        this.options.deviceId = (0, Utility_1.defaultToAny)(this.options.deviceId, platformConfiguration.deviceId);
                        this.options.isIntegration = (0, Utility_1.defaultToAny)(this.options.isIntegration, platformConfiguration.isIntegration, false);
                        this.options.platformConfig = (0, Utility_1.defaultToAny)(this.options.platformConfig, platformConfiguration.platformConfig, false);
                        this.options.ui = (0, Utility_1.defaultToAny)(this.options.ui, platformConfiguration.ui, undefined);
                        this.options.layout = (0, Utility_1.defaultToAny)(this.options.layout, platformConfiguration.layout, undefined);
                        this.options.betslip = (0, Utility_1.defaultToAny)(this.options.betslip, platformConfiguration.betslip, undefined);
                        this.options.scrollButtons = (0, Utility_1.defaultToAny)(this.options.scrollButtons, platformConfiguration.scrollButtons, undefined);
                        this.options.moneyDenominations = (0, Utility_1.defaultToAny)(this.options.moneyDenominations, platformConfiguration.moneyDenominations, undefined);
                        if (typeof this.platformConfiguratedCallback === 'function') {
                            callbackOptions = (0, Utility_1.merge)(this.options, {
                                messageProtocol: Registry_1.registry.messageProtocols[this.options.messageProtocol]
                            });
                            this.platformConfiguratedCallback(callbackOptions);
                        }
                        return [4 /*yield*/, this.getHttpAdaptersConfiguration()];
                    case 2:
                        httpAdaptersConfiguration = _a.sent();
                        tenantConfiguration = TenantRegistry_1.tenantRegistry.tenants[this.options.tenantId];
                        product = Registry_1.registry.getProduct(this.options.productName);
                        configuration = (0, Utility_1.merge)({
                            environment: this.options.environment,
                            platformName: this.options.platformName,
                            platformDataCenter: this.options.platformDataCenter,
                            productName: this.options.productName,
                            productFqn: product.fqn,
                            productId: this.options.productId,
                            productUuid: this.options.productUuid,
                            tenantId: this.options.tenantId,
                            locale: this.options.locale,
                            applicationName: this.options.applicationName,
                            channelId: this.options.channelId,
                            betshopId: this.options.betshopId,
                            deviceId: this.options.deviceId,
                            isIntegration: this.options.isIntegration,
                            messageProtocol: Registry_1.registry.messageProtocols[this.options.messageProtocol],
                            localConfig: platformConfiguration.localConfig,
                            platformConfig: this.options.platformConfig,
                            user: platformConfiguration.user,
                            layout: this.options.layout,
                            betslip: this.options.betslip,
                            scrollButtons: this.options.scrollButtons,
                            moneyDenominations: this.options.moneyDenominations,
                        }, httpAdaptersConfiguration, this.busConfiguration, tenantConfiguration);
                        if (requiredPaths && requiredPaths.length > 0) {
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    var checkInterval = setInterval(function () {
                                        var isRequired = true;
                                        for (var _i = 0, requiredPaths_1 = requiredPaths; _i < requiredPaths_1.length; _i++) {
                                            var requiredPath = requiredPaths_1[_i];
                                            if ((0, Utility_1.isNil)((0, Utility_1.get)(configuration, requiredPath))) {
                                                isRequired = false;
                                                break;
                                            }
                                        }
                                        if (isRequired) {
                                            clearInterval(checkInterval);
                                            resolve(configuration);
                                        }
                                        else {
                                            checkTime += checkIntervalTime;
                                            if (checkTime > checkIntervalTimeout) {
                                                clearInterval(checkInterval);
                                                reject(Types_1.ConfigurationErrors.TimeoutError);
                                            }
                                        }
                                        (0, Utility_1.merge)(configuration, _this.busConfiguration);
                                    }, checkIntervalTime);
                                })];
                        }
                        return [2 /*return*/, configuration];
                }
            });
        });
    };
    ConfigurationService.prototype.setBusListener = function () {
        var _this = this;
        /*
        We are waiting on bus events here for completion of configuration.
        This case covers games like VDR where initial configuration depends on socket state.
        It is required to use proxyEvents config in bus service to map event to proper SetConfiguration.
        */
        if (window.addEventListener) {
            window.addEventListener('Bus:SetConfiguration', (function (event) {
                if (event.detail) {
                    (0, Utility_1.merge)(_this.busConfiguration, {
                        state: __assign({}, event.detail),
                    });
                }
            }), {
                once: true,
            });
        }
    };
    ConfigurationService.prototype.onPlatformConfigurated = function (callback) {
        this.platformConfiguratedCallback = callback;
    };
    return ConfigurationService;
}());
exports.ConfigurationService = ConfigurationService;
//# sourceMappingURL=ConfigurationService.js.map